import type { Selection } from "react-aria-components";
import { useCallback, useMemo } from "react";

import type { AdaptedQueueRow } from "../helpers/adapters";
import { isStatusSettled } from "../helpers/isStatusSettled";
import {
  useCosignatureSelectionActions,
  useCosignatureSelectionState,
} from "../../CosignatureSelectionProvider";

type UseCosignatureSelectionParams = {
  rows: AdaptedQueueRow[];
  sortedRows: AdaptedQueueRow[];
};

export function useCosignatureSelection({ rows, sortedRows }: UseCosignatureSelectionParams) {
  const { selectedKeys } = useCosignatureSelectionState();
  const { selectRows } = useCosignatureSelectionActions();

  const disabledKeys = useMemo(
    () => new Set(rows.filter((r) => isStatusSettled(r.status)).map((r) => r.id)),
    [rows],
  );

  const onSelectionChange = useCallback(
    (selection: Selection) => {
      const resolvedRows =
        selection === "all"
          ? sortedRows.filter((r) => !isStatusSettled(r.status))
          : rows.filter((r) => selection.has(r.id));

      selectRows(resolvedRows);
    },
    [rows, sortedRows, selectRows],
  );

  return { disabledKeys, onSelectionChange, selectedKeys };
}
